<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
        <div calss="form-group row">
                <div class="col-md-6">
                        <h1>REKAPITULACIJA IZVODA - opis</h1>            
                </div>    
        </div>  
    <div class="row">
        <div class="col-lg-6 col-12">
            <div class="form-group row">
                <div class="col-md-6">
                    <yt-fw-date-picker-popup
                        name="txtOdDatuma"
                        formControlName="OdDatuma"
                        [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                        [Label]="'REKAPITULACIJAIZVODA.ODDATUMA.SINGULAR'">
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                        <span *ngFor="let validation of errorMessages.OdDatuma">
                            <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <yt-fw-date-picker-popup
                        name="txtDoDatuma"
                        formControlName="DoDatuma"
                        [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                        [Label]="'REKAPITULACIJAIZVODA.DODATUMA.SINGULAR'">
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                        <span *ngFor="let validation of errorMessages.DoDatuma">
                            <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>  
    <div class="row">
        <div class="col-lg-6 col-12">
            <div class="form-group row">
                <!-- <label class="control-label col-md-2"><span>Komitent</span></label> -->
                <div class="col-md-12">
                    <yt-multiselect
                        [ModelName]="'komitent'"
                        [GetName]="'get'"
                        [ModelProperty]="'SNaziv'"
                        [OrderBy]="'SNaziv'"
                        formControlName="Komitent"
                        [AllowAddNew]="false" 
                        [Type]="'ID'"
                        [Label]="'REKAPITULACIJAIZVODA.KOMITENT.SINGULAR'"
                        [ngClass]="{'is-invalid': submitted && fc.Komitent.invalid}">
                    </yt-multiselect>
                    <div class="form-error" *ngIf="submitted && fc.Komitent.invalid">
                        <span *ngFor="let validation of errorMessages.Komitent">
                            <span class="error-message" *ngIf="fc.Komitent.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-12">
            <div class="form-group row">
                <!-- <label class="control-label col-md-2"><span>Organ. jed.</span></label> -->
                <div class="col-md-12">
                    <yt-multiselect
                        [ModelName]="'orgjed'"
                        [GetName]="'GetByParentID'"
                        [ModelProperty]="'Naziv'"
                        [OrderBy]="'Naziv'"
                        formControlName="OrgJed"
                        [AllowAddNew]="false" 
                        [Type]="'ID'"
                        [Label]="'REKAPITULACIJAIZVODA.ORGJED.SINGULAR'"  
                        [ngClass]="{'is-invalid': submitted && fc.OrgJed.invalid}">
                    </yt-multiselect>
                    <div class="form-error" *ngIf="submitted && fc.OrgJed.invalid">
                        <span *ngFor="let validation of errorMessages.OrgJed">
                            <span class="error-message" *ngIf="fc.OrgJed.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-12">
            <div class="form-group row">
                <label for="rdbGrupisanoPo" class="control-label col-md-2"><span translate="REKAPITULACIJAIZVODA.VRSTA.IZVESTAJ"></span></label>
                <div class="col-md-2">
                    <label class="radio-inline">
                        <input type="radio" value=1 formControlName="Vrsta">
                        <span translate="REKAPITULACIJAIZVODA.VRSTA.ANALITIKA"></span>
                    </label>
                </div>
                <div class="col-md-2">
                    <label class="radio-inline">
                        <input type="radio" value=2 formControlName="Vrsta">
                        <span translate="REKAPITULACIJAIZVODA.VRSTA.SINTETIKA"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
   
   
    <div class="row">
        <div class="col-md-12">
            <button type="button" class="btn btn-primary" (click)="LoadPDF()">Učitaj</button>
        </div>
    </div>
</form>